import { LoadingType } from 'src/store';
import { ImageEntity } from 'src/modules/global';
import { HomePageEntity } from 'src/modules/pages';

export enum PagesActions {
  FetchPageBegin = 'PAGES/FETCH/BEGIN',
  FetchPageSuccess = 'PAGES/FETCH/SUCCESS',
  FetchPageError = 'PAGES/FETCH/ERROR',
  FetchMarketingPageBegin = 'MARKETING_PAGES/FETCH/BEGIN',
  FetchMarketingPageSuccess = 'MARKETING_PAGES/FETCH/SUCCESS',
  FetchMarketingPageError = 'MARKETING_PAGES/FETCH/ERROR',
}

export interface PagesStore extends LoadingType {
  pages: Record<string, PageEntity | HomePageEntity>;
  page?: PageTypes;
  marketingPage?: MarketingPageEntity;
  currentPageKey: null | PageKeys;
}

export type PageTypes = PageEntity | HomePageEntity;

export interface PageEntity {
  name: string;
  key: string;
  title_en: string;
  title_de: string;
  subtitle_en: string;
  subtitle_de: string;
  meta_title_en: string;
  meta_title_de: string;
  meta_description_en: string;
  meta_description_de: string;
  image: ImageEntity;
  dynamic_content?: any[];
}

export interface PageLocalizedEntity
  extends Pick<
    PageEntity,
    Exclude<
      keyof PageEntity,
      | 'title_en'
      | 'title_de'
      | 'subtitle_en'
      | 'subtitle_de'
      | 'meta_title_en'
      | 'meta_title_de'
      | 'meta_description_en'
      | 'meta_description_de'
    >
  > {
  title: string;
  subtitle: string;
  meta_title: string;
  meta_description: string;
  dynamic_content?: any[];
}
export interface MarketingPageEntity {
  name: string;
  key: string;
  title_en: string;
  title_de: string;
  // meta_title_en: string;
  // meta_title_de: string;
  meta_description_en: string;
  meta_description_de: string;
  image: ImageEntity;
  dynamic_content?: any[];
}

export interface MarketingPageLocalizedEntity
  extends Pick<
    MarketingPageEntity,
    Exclude<
      keyof MarketingPageEntity,
      | 'title_en'
      | 'title_de'
      // | 'subtitle_en'
      // | 'subtitle_de'
      // | 'meta_title_en'
      // | 'meta_title_de'
      | 'meta_description_en'
      | 'meta_description_de'
    >
  > {
  title: string;
  // subtitle: string;
  // meta_title: string;
  meta_description: string;
}

export interface CareerPageEntity {
  name: string;
  key: string;
  title_en: string;
  title_de: string;
  // meta_title_en: string;
  // meta_title_de: string;
  meta_description_en: string;
  meta_description_de: string;
  dynamic_content_top?: any[];
  dynamic_content_bottom?: any[];
  normal_jobs_headline_en: string;
  normal_jobs_headline_de: string;
  educational_jobs_headline_en: string;
  educational_jobs_headline_de: string;
}

export interface CareerPageLocalizedEntity
  extends Pick<
    CareerPageEntity,
    Exclude<
      keyof CareerPageEntity,
      | 'title_en'
      | 'title_de'
      | 'meta_description_en'
      | 'meta_description_de'
      | 'normal_jobs_headline_en'
      | 'normal_jobs_headline_de'
      | 'educational_jobs_headline_en'
      | 'educational_jobs_headline_de'
    >
  > {
  title: string;
  // subtitle: string;
  // meta_title: string;
  meta_description: string;
  normal_jobs_headline: string;
  educational_jobs_headline: string;
}

export enum PageKeys {
  ProfessionalsOverview = 'professionals-overview',
  MagazineOverview = 'magazine-overview',
  MagazinesAndBrochures = 'magazines-and-brochures',
  InstagramOverview = 'instagram-overview',
  ProfessionalsDownloadsOverview = 'professionals-downloads-overview',
  AboutOverview = 'about-overview',
  AboutQuality = 'quality-environment',
  AboutVision = 'vision',
  AboutHistory = 'history',
  Homepage = 'homepage',
  Press = 'press',
  Imprint = 'imprint',
  Terms = 'terms',
  Privacy = 'privacy',
  Careers = 'careers',
  Sales = 'sales',
  Pcon = 'pcon',
  NotFound = 'not-found',
  Newsletter = 'newsletter',
  QuickShip = 'quick-ship',
}
